<template>
  <nuxt-link :to="productRoute(product.ecomId)" class="flex mb-12">
    <div
      class="
        flex-shrink-0 flex
        items-center
        justify-center
        mr-12
        rounded-regular
        overflow-hidden
        w-70
      "
      :style="`background: ${background}`"
    >
      <img
        :src="product.standardImage"
        :class="{
          'opacity-50': !product.available,
        }"
        alt="Produktbild"
        class="object-cover h-full w-full"
      >
    </div>
    <div>
      <span class="text-small mb-4">{{ product.title }}</span>
      <div v-if="product.showAsOnSale">
        <span
          class="bold text-warning text-medium-small"
          :content="product.priceAsNumber"
        >
          {{ product.price }}
        </span>
        <span
          class="bold line-through text-grey text-medium-small"
          :content="product.priceBeforeDiscountAsNumber"
        >
          {{ product.priceBeforeDiscount }}
        </span>
      </div>
      <span v-else class="bold text-medium-small mb-8 block">
        {{ product.price }}
      </span>
      <div class="flex">
        <div
          v-for="item in product.items"
          :key="'product-search-item-size-' + product.ecomId + item.item"
          class="text-size-chart mr-8 last:mr-0"
          :class="{
            'text-muted': item.stock === 'yes',
            'line-through text-black-50': item.stock !== 'yes',
          }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="flex mt-12">
        <div
          v-for="variant in productVariants"
          :key="'product-spot-variant-' + variant.itemId"
          class="h-12 w-12 border rounded-full mr-8"
          :class="{
            'border-transparent': variant.itemId !== product.itemId,
            'border-muted': variant.itemId === product.itemId,
          }"
        >
          <div
            class="border border-white rounded-full h-full w-full"
            :style="`background-color: ${
              variant.color.hex === '#ffffff' ? '#EAE9E8' : variant.color.hex
            }`"
          />
        </div>
      </div>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
import type { EcomProduct } from '~/constants/types/product';
import Product from '~/models/product';
import { useConfigStore } from '~/store/config';
const config = useConfigStore();

const props = defineProps<{
  item: EcomProduct,
}>();

const colorLangList = {
  blue: ['Blå', 'Sinninen', 'Blå', 'Blå'],
  green: ['Grön', 'Vihreä', 'Grønn', 'Grön'],
  red: ['Röd', 'Punainen', 'Rød', 'Röd'],
};

const product = computed(()=> {
  return new Product({ ecomData: props.item, contentData: null });
});

const productVariants = computed<Product[]>(()=> {
  const variants = product.value.variants;
  return variants
    .reverse()
    .filter((p) => p.category === product.value.category);
});

const background = computed(()=> {
  if (colorLangList.blue.includes(product.value.color.desc)) {
    return '#DCE1E6';
  } else if (colorLangList.red.includes(product.value.color.desc)) {
    return '#F3E8E2';
  } else if (colorLangList.green.includes(product.value.color.desc)) {
    return '#DCDFDC';
  } else {
    return '#EAE9E8';
  }
});

const productRoute = (id: number) => {
  return config.getProductRoute(Number(id))?.route || '/';
};

</script>

<style scoped lang="postcss">
</style>
